import { ICandidateSourcingFilters, FilterKey } from '../types';

export const addFilterValue = (
  filters: ICandidateSourcingFilters,
  key: FilterKey,
  value: string
): ICandidateSourcingFilters => {
  const newFilters = { ...filters };

  switch (key) {
    case 'job_titles':
      newFilters.job_titles = [...(newFilters.job_titles || []), value];
      break;
    case 'industries':
      newFilters.industries = [...(newFilters.industries || []), value];
      break;
    case 'skills':
      newFilters.skills = [...(newFilters.skills || []), [value]];
      break;
    case 'location':
      newFilters.location = value;
      break;
    case 'years_of_experience':
      newFilters.years_of_experience = parseInt(value);
      break;
  }

  return newFilters;
};

export const removeFilterValue = (
  filters: ICandidateSourcingFilters,
  key: FilterKey,
  index?: number,
  subIndex?: number
): ICandidateSourcingFilters => {
  const newFilters = { ...filters };

  switch (key) {
    case 'job_titles':
      if (index !== undefined) {
        newFilters.job_titles = newFilters.job_titles?.filter((_, i) => i !== index);
      }
      break;
    case 'industries':
      if (index !== undefined) {
        newFilters.industries = newFilters.industries?.filter((_, i) => i !== index);
      }
      break;
    case 'skills':
      if (index !== undefined && subIndex !== undefined) {
        newFilters.skills = newFilters.skills
          ?.map((group, i) => (i === index ? group.filter((_, j) => j !== subIndex) : group))
          .filter((group) => group.length > 0);
      }
      break;
    case 'location':
      delete newFilters.location;
      break;
    case 'years_of_experience':
      delete newFilters.years_of_experience;
      break;
  }

  return newFilters;
};
